document.addEventListener('DOMContentLoaded', function () {
  const content = document.getElementById('short-desc-content');
  const btn = document.getElementById('read-more-btn');
  const maxLines = 5;

  if (!content || !btn) return;

  function resolveLineHeight() {
    const sample = content.querySelector('li, p, strong, span, *') || content;
    const style = getComputedStyle(sample);
    const fontSize = parseFloat(style.fontSize) || 16;
    let lineHeight = parseFloat(style.lineHeight);

    if (!Number.isFinite(lineHeight) || lineHeight < fontSize * 0.8) {
      lineHeight = fontSize * 1.5;
    }

    return lineHeight;
  }

  function snapToLastVisibleLine(approxHeight) {
    const contentRect = content.getBoundingClientRect();
    const scrollTop = content.scrollTop || 0;
    const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
    let lastBottom = 0;
    let node;

    while ((node = walker.nextNode())) {
      if (!node.nodeValue || !node.nodeValue.trim()) continue;

      const range = document.createRange();
      range.selectNodeContents(node);
      const rects = Array.from(range.getClientRects());

      for (const rect of rects) {
        if (rect.height < 1 || rect.width < 1) continue;
        const bottom = rect.bottom - contentRect.top + scrollTop;

        if (bottom <= approxHeight + 0.5) {
          lastBottom = Math.max(lastBottom, bottom);
        } else {
          return lastBottom > 0 ? Math.ceil(lastBottom) : Math.floor(approxHeight);
        }
      }
    }

    return lastBottom > 0 ? Math.ceil(lastBottom) : Math.floor(approxHeight);
  }

  function collapseHeight() {
    const approx = Math.max(resolveLineHeight() * maxLines, 72);
    return snapToLastVisibleLine(approx);
  }

  const maxHeight = collapseHeight();

  if (content.scrollHeight > maxHeight + 4) {
    content.style.maxHeight = maxHeight + 'px';
    content.classList.add('is-collapsed');
    btn.style.display = 'block';
  } else {
    content.classList.remove('is-collapsed');
    content.style.maxHeight = '';
  }

  btn.addEventListener('click', function () {
    const collapsed = content.classList.contains('is-collapsed');

    if (collapsed) {
      content.style.maxHeight = '';
      content.classList.remove('is-collapsed');
      btn.textContent = btn.dataset.less;
    } else {
      content.style.maxHeight = collapseHeight() + 'px';
      content.classList.add('is-collapsed');
      btn.textContent = btn.dataset.more;
    }
  });
});
